import ElementPropertiesManager from 'assets/core/js/module/element-properties-manager'
import type { SelectCustom } from '@ui/SelectCustom/component'

const resetSelect = (el: HTMLSelectElement): void => {
  const selectCustom = ElementPropertiesManager.getProperty<SelectCustom>(el, 'select')

  // setValues() only deselects `option[selected]`
  selectCustom?.setValues([])
  el.value = ''
}

export default function (): void {
  document.querySelectorAll('.dashboard__filters-reset').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()

      document
        .getElementById('dashboard-form')
        ?.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input, select')
        .forEach((el) => {
          if (el instanceof HTMLSelectElement) {
            resetSelect(el)
          } else {
            el.value = ''
          }
        })
    })
  })
}
